export const LOAD_CAMPAIGNS = 'app/CashbackCampaignsContainer/LOAD_CAMPAIGNS';
export const LOAD_CAMPAIGNS_SUCCESS =
  'app/CashbackCampaignsContainer/LOAD_CAMPAIGNS_SUCCESS';
export const LOAD_CAMPAIGNS_ERROR =
  'app/CashbackCampaignsContainer/LOAD_CAMPAIGNS_ERROR';
